import styled from "styled-components"
import { Colors } from 'styles/app-styles'
import DataTable_s from "components/table/data-table-styles"
import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"

export const NamedRecoveriesTable_s = styled(DataTable_s)`
  border-spacing: 15px;

  table.p-datatable-scrollable-header-table, table.p-datatable-scrollable-body-table {
    width: auto;
  }

  table.p-datatable-scrollable-body-table {
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  }

  .p-datatable-thead > tr {
    height: 30px;
  }

  // Hide filter input row
  .p-datatable-unfrozen-view thead.p-datatable-thead > tr:last-child {
    display: none;
  }

  .systemImmutable-row {
    background: ${Colors.athensGrey} !important;
  }
  .system-row .system-disabled {
    background: ${Colors.athensGrey};
  }

  .p-paginator {
    bottom: 0px;
  }

  ${() => {
    // hack for dealing with different style behavior between n/rent-roll/named-recoveries and n/recoveries/named-recoveries
    return window.location.pathname !== '/n/rent-roll/named-recoveries' ? '' : `
    .selection-count {
      bottom: 8px;
      font-size: smaller;
      margin-left: 92px;
      position: absolute;
      z-index: 999;
    }
  `
  }}
`

type CapProps = {
  cap?: boolean
}

export const ProRataRecovery_s = styled.div<CapProps>`
  ${SingleRowCarouselState_s}{
    margin-bottom: 15px;
  }
  .billion-input {
    width: 120px;
  }
  .denominator {
    width: 180px;
  }
  .reporttag {
    width: 200px;
  }
  .short-input {
    width: 100px !important;
  }
  .stop-type {
    width: 140px;
  }
  summary {
    padding: 10px 15px;
    ${props => { if (props.cap) return `&:after {
      border-radius: 100%;
      background-color: ${Colors.colorDanger};
      content: "";
      height: 12px;
      position: absolute;
      margin-left: 20px;
      margin-top: 3px;
      width: 12px;
    }`}}
  }
  .clear-btn {
    display: flex;
    justify-content: end;
    margin: -35px 5px 15px 0;
  }
  details {
    border: 1px solid ${Colors.towerGrey};
    min-width: 100px;
    ${SingleRowCarouselState_s}{
      padding: 0px 15px;
    }
    .cap-date{
      width: 160px;
    }
  }
`